import Accordion from "@/components/Accordion";
import React from "react";
import { BookAppointment } from "./BookAppointment";
import { KnowledgeBase } from "./KnowledgeBase";
import { Content } from "./Content";
import { Call } from "./Call";
import { ChatWindow } from "../../types";
import { LanguageConfigModel, StyleConfigModel } from "@/pages/Messaging/types";
import ChatWindowPreview from "../../Preview/ChatWindowPreview";
import { ClickToCall } from "./ClickToCall";

interface Props {
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export default function Widgets(props: Props) {
  const [selectedScreen, setSelectedScreen] = React.useState("Calendly");

  const previewScreens = [
    {
      label: "Calendly",
      action: () => setSelectedScreen("Calendly"),
      name: "Calendly"
    },
    {
      label: "Click to Call",
      action: () => setSelectedScreen("Landing"),
      name: "Landing"
    }
  ];

  return (
    <div className="panel flex bg-white rounded-2xl shadow-md w-full border">
      <div className="p-6 border-r border-slate-300 w-full">
        <div className="text-lg font-medium mb-2">Widgets</div>
        <div className="text-sm font-normal text-slate-600 mb-4">
          Customize your chat window with interactive widgets. Widgets are
          customizable cards for quick access to key features.
        </div>
        <div className="overflow-auto">
          <Accordion>
            <BookAppointment
              onExpanded={() => {
                setSelectedScreen("Calendly");
              }}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <ClickToCall
              onExpanded={() => {
                setSelectedScreen("Landing");
              }}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            {/* <KnowledgeBase onExpanded={() => {}} />
          <Content onExpanded={() => {}} />
          <Call onExpanded={() => {}} /> */}
          </Accordion>
        </div>
      </div>
      <div className="w-full">
        <ChatWindowPreview
          chatWindow={props.workingChatWindow}
          previewScreens={previewScreens}
          selectedScreen={selectedScreen}
          setSelectedScreen={setSelectedScreen}
        />
      </div>
    </div>
  );
}
